import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'styled-components'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import Text from '@navent-jobs/ui-kit/components/text'

// styles
import { WordingContainer, IconCustom, LabelButtonEstadisticas, ButtonEstadisticas, Wrapper } from './mixins'

// constants
import { DataLayers } from '../../../../../../../constants/gtm-events-button-estaisticas'

// Components
import Preguntas from '../preguntas-pendientes'

const Component = ({
  avisoState,
  postulacionState,
  postPostulacion,
  setVisibleModalPreguntasPendientes,
  showPreguntasPendientes,
}) => {
  const { isMobile, isTabletPortrait } = useScreenSize()
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)

  const idPostulacion = postulacionState?.idPostulacion || postPostulacion?.idPostulacion
  const fecha = postulacionState?.fecha?.replace(/-/g, '/') || postPostulacion?.fecha?.replace(/-/g, '/')
  const hasAvisoFinalizado = avisoState?.toLowerCase() === 'offline'

  return (
    <Wrapper>
      {showPreguntasPendientes && <Preguntas setVisibleModalPreguntasPendientes={setVisibleModalPreguntasPendientes} />}

      <WordingContainer hasPreguntasPendientes={showPreguntasPendientes}>
        <IconCustom
          name="icon-light-checkbox-checked"
          size={showPreguntasPendientes ? '24' : '32'}
          color={colors.secondary.normal}
          marginRight="4px"
        />
        <Text size="lg" variant="secondary" fontWeight="semibold" as="h1">
          {t('fichaAviso.postulado', { fecha })}
        </Text>
      </WordingContainer>

      {(isMobile || isTabletPortrait) && !hasAvisoFinalizado && (
        <ButtonEstadisticas
          href={`/postulantes/postulaciones/estadisticas-${idPostulacion}`}
          onClick={() => DataLayers.VerEstadisticasOnClick('aviso')}
          linkoptions={{
            size: 'small',
            variant: 'primary',
            type: 'outline',
            native: true,
          }}
        >
          <IconCustom name="icon-light-graph" size="20" />
          <LabelButtonEstadisticas>Ver estadísticas del aviso </LabelButtonEstadisticas>
        </ButtonEstadisticas>
      )}
    </Wrapper>
  )
}

export default Component
